import { Box } from '@palmetto/palmetto-components';

import { AllDocumentTypes, documentTitles } from 'types';

import EventBy from './EventBy';

const SabalDocumentMoved = ({ event }: { event: any }) => {
  const fileName = event.data?.document?.files?.[0]?.originalName;
  const previousDocumentType: AllDocumentTypes = event.data?.previousType;
  const newDocumentType: AllDocumentTypes = event.data?.newType;
  return (
    <Box display="block">
      <EventBy event={event} /> moved document <strong>{fileName}</strong> from{' '}
      <strong>{documentTitles[previousDocumentType]}</strong> to {` `}
      <strong>{documentTitles[newDocumentType]}</strong>
    </Box>
  );
};

export default SabalDocumentMoved;
